export default "__VITE_ASSET__70282de5__"